<template>
  <div
    id="menu"
    :class="showFilters ? 'down' : ''"
    v-click-outside="hide"
  >
    <div
      class="filter"
      @click="showHideFilters()"
    >
      <div>
        {{ $t('shared.sortingMenu.sortingBy') }}
        <span>{{ sortType() }}</span>
      </div>
      <img src="@/assets/Arrow-Down.svg" />
    </div>
    <ul id="list">
      <li @click="sort('chronology')">
        {{ $t('shared.sortingMenu.chronology') }}
      </li>
      <li @click="sort('popularity')">
        {{ $t('shared.sortingMenu.popularity') }}
      </li>
      <li v-if="type === 'communities'" @click="sort('alphabetical')">
        {{ $t('shared.sortingMenu.alphabeticalOrder') }}
      </li>
    </ul>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
export default {
  name: 'SortingMenu',
  directives: {
    ClickOutside
  },
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showFilters: false
    }
  },
  created () {
    this.$store.dispatch('resetSortPosts')
    this.$store.dispatch('resetSortCommunities')
  },
  methods: {
    showHideFilters () {
      this.showFilters = !this.showFilters
    },
    sort (sortBy) {
      switch (this.type) {
        case 'communities' :
          this.$store.dispatch('sortCommunities', sortBy)
          break
        case 'posts' :
          this.$store.dispatch('sortPosts', sortBy)
          break
      }
      this.showFilters = false
    },
    sortType () {
      let sortType
      switch (this.type) {
        case 'posts' :
          sortType = this.$store.getters.postsSort
          break
        case 'communities' :
          sortType = this.$store.getters.communitiesSort
          break
      }
      if (sortType === 'alphabetical') {
        sortType = this.$t('shared.sortingMenu.alphabeticalOrder')
      } else if (sortType === 'popularity') {
        sortType = this.$t('shared.sortingMenu.popularity')
      } else {
        sortType = this.$t('shared.sortingMenu.chronology')
      }

      return sortType
    },
    hide () {
      this.showFilters = false
    }
  }

}
</script>

<style scoped lang="scss">
#menu {
  margin: 0 1rem;
  display:flex;
  justify-content: flex-end;
}
.filter {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  span {
    font-weight: 800;
    color: $primary-color;
  }
}

#menu #list {
  width: 270px;
  transition: max-height 0.15s ease-out;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  list-style-type: none;
  background-color: white;
  max-height: 0;
  padding-inline-start: 0;
  overflow: hidden;
  position: absolute;
  margin: 30px 0 0;
  z-index: 1;
  li {
    display: flex;
    align-items: flex-start;
    color: $primary-color;
    width: 100%;
    padding: 0.5rem 1rem;
    cursor: pointer;
    &:hover {
      background-color: $primary-color;
      color: white;
    }
  }
}

#menu.down #list {
  max-height: 120px;
  transition: max-height 0.10s ease-in;
  box-shadow: 2px 2px 8px 2px rgba(69, 69, 69, 0.1);
}
</style>
